const toCount = (value) => {
  const count = Number(value);
  return Number.isFinite(count) && count > 0 ? count : 0;
};

export const getBatchUploadValidBreakdown = ({
  totalValid = 0,
  newRows = 0,
  updatedRows = 0,
  skippedRows,
} = {}) => {
  const created = toCount(newRows);
  const updated = toCount(updatedRows);
  const skipped = toCount(skippedRows);
  const total = toCount(totalValid);
  const hasExplicitBreakdown =
    newRows !== undefined ||
    updatedRows !== undefined ||
    skippedRows !== undefined;

  return {
    created,
    updated,
    skipped,
    total,
    hasBreakdown:
      hasExplicitBreakdown || created > 0 || updated > 0 || skipped > 0,
  };
};

export const getBatchUploadBreakdownItems = (breakdown) =>
  breakdown?.hasBreakdown
    ? [
        {
          key: "total",
          count: breakdown.total,
          label: "{{count}} Total Valid",
          tone: "success",
        },
        {
          key: "created",
          count: breakdown.created,
          label: "{{count}} Created",
          tone: "success",
        },
        {
          key: "updated",
          count: breakdown.updated,
          label: "{{count}} Updated",
          tone: "success",
        },
        {
          key: "skipped",
          count: breakdown.skipped,
          label: "{{count}} Skipped",
          tone: "muted",
        },
      ].filter((item) => item.count > 0)
    : [];

export const getBatchUploadRowAction = (entry = {}) =>
  entry._uploadAction === "update" || entry.dataEntryId ? "update" : "new";
